import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { ServicesProvider } from '../ServicesProvider.js';
import { Services } from './Services.js';
import { servicesProviderFinancingBrokerageSubventionDataSchema } from './ServicesProviderFinancingBrokerageSubventionData.js';

class ServicesProviderFinancingBrokerageSubvention extends ServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
    }
    validateData(data) {
        const result = servicesProviderFinancingBrokerageSubventionDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderFinancingBrokerageSubvention.validation', `ServicesProviderFinancingBrokerageSubvention data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.FINANCING_BROKERAGE_SUBVENTION,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.FINANCING_BROKERAGE_SUBVENTION, ServicesProviderFinancingBrokerageSubvention);

export { ServicesProviderFinancingBrokerageSubvention };
//# sourceMappingURL=ServicesProviderFinancingBrokerageSubvention.js.map
